import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';
import functions from '../../../functions/';
import ParadigmaTable from "../../../components/ParadigmaTable/";

class Movimientos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Link",
                    id: "Link",
                    accessor: "Link",
                    show: false,
                    private: true,
                },
                {
                    Header: "Cod. Cuenta",
                    id: "CodCuenta",
                    accessor: d => d.CodCuenta,
                    className:"text-center",
                    show: true,
                },
                {
                    Header: "Fecha",
                    id: "Fecha",
                    className:"text-center",
                    accessor: d => functions.FormatDate(d.Fecha),
                    show: true,
                },
                {
                    Header: "Vencimiento",
                    id: "FechaVencimiento",
                    className:"text-center",
                    accessor: d => functions.FormatDate(d.FechaVencimiento),
                    show: true,
                },
                {
                    Header: "Tipo de Movimiento",
                    id: "TipoMovimiento",
                    accessor: d => d.TipoMovimiento,
                    show: true,
                },
                {
                    Header: "Tipo de Comprobante",
                    id: "TipoComprobante",
                    accessor: d => d.TipoComprobante,
                    show: true,
                },
                {
                    Header: "Leyenda",
                    id: "Leyenda",
                    accessor: d => d.Leyenda,
                    show: true,
                },
                {
                    Header: "NroComprobante",
                    id: "NroComprobante",
                    className:"text-center",
                    Cell: d => d.original.Link ? <a target="_blank" href={`${d.original.Link}`}>{d.original.NroComprobante}</a> : d.original.NroComprobante,
                    show: true,
                },
                {
                    Header: "Importe",
                    id: "Importe",
                    className:"text-right",
                    accessor: d => `$ ${functions.FormatPrice(d.Importe)}`,
                    show: true,
                },
                {
                    Header: "Importe Aplicado",
                    id: "ImporteAplicado",
                    className:"text-right",
                    accessor: d => `$ ${functions.FormatPrice(d.ImporteAplicado)}`,
                    show: true,
                },
                {
                    Header: "Saldo",
                    id: "Saldo",
                    className:"text-right",
                    accessor: d => `$ ${functions.FormatPrice(d.Saldo)}`,
                    show: true,
                },
                {
                    Header: "Acumulado",
                    id: "Acumulado",
                    className:"text-right",
                    accessor: d => `$ ${functions.FormatPrice(d.Acumulado)}`,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                apiUrl={api.gestion.cuentascorrientes.movimientos}
                columns={this.state.columns}
                title={"Movimientos de Cuentas Corrientes"}
            />
        );
    }
}

export default Movimientos;



// WEBPACK FOOTER //
// ./src/views/Gestion/CuentasCorrientes/Movimientos.js